import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/yanre/Logo";
import { INSTITUTIONAL_WEBSITE_URL } from "@/config";
import { track } from "@/lib/track";
import { openCookiePreferences } from "@/lib/consent";
import { useLocale } from "@/i18n/LocaleContext";

// Legal links are placeholders pending the legal pages; company info to be confirmed.
// VISIT YANRE FITNESS EUROPE WEBSITE activates once INSTITUTIONAL_WEBSITE_URL
// (src/config.js) holds a verified production URL.
export const LandingFooter = () => {
  const { locale, t } = useLocale();
  const visitInner = (
    <>
      {t("footer.visit", "Visit YANRE FITNESS EUROPE Website")}
      <ArrowUpRight className="h-3.5 w-3.5 text-signal" />
    </>
  );
  const visitCls = "inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-titanium/50 transition-colors hover:text-white";
  return (
    <footer className="border-t border-carbon-700 bg-carbon-950" data-testid="landing-footer">
      <div className="container-edge py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-titanium/50">
              {t("footer.tagline", "YANRE FITNESS EUROPE — the European home of an established international manufacturer of commercial-grade strength systems and complete fitness solutions.")}
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-titanium/40">{t("footer.contact", "Contact")}</p>
            <div className="mt-5 space-y-3 text-sm text-titanium/70">
              <p>
                <a href="mailto:yanre-eu@yanrefitness.com" className="transition-colors hover:text-white" data-testid="footer-email">
                  yanre-eu@yanrefitness.com
                </a>
              </p>
              <p>
                <a href="tel:+351910619033" className="transition-colors hover:text-white" data-testid="footer-phone">
                  +351 910 619 033
                </a>
              </p>
              <p>
                {INSTITUTIONAL_WEBSITE_URL ? (
                  <a href={INSTITUTIONAL_WEBSITE_URL} target="_blank" rel="noopener" onClick={() => track("visit_website_click", { placement: "footer" })} className={visitCls} data-testid="footer-visit-website">
                    {visitInner}
                  </a>
                ) : (
                  <span role="link" aria-disabled="true" title="Institutional website — link pending" className={`${visitCls} cursor-default hover:text-titanium/50`} data-testid="footer-visit-website">
                    {visitInner}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-titanium/40">{t("footer.legal", "Legal")}</p>
            <div className="mt-5 space-y-3 text-sm text-titanium/70">
              <p><a href="#" className="transition-colors hover:text-white" data-testid="footer-privacy">{t("footer.privacy", "Privacy Policy")}</a></p>
              <p><Link to={locale === "en" ? "/cookie-policy" : `/${locale}/cookie-policy`} className="transition-colors hover:text-white" data-testid="footer-cookies">{t("footer.cookies", "Cookie Policy")}</Link></p>
              <p>
                <button type="button" onClick={openCookiePreferences} className="transition-colors hover:text-white" data-testid="cookie-preferences-footer-link">
                  {t("footer.cookiePrefs", "Cookie Preferences")}
                </button>
              </p>
              <p><a href="#" className="transition-colors hover:text-white" data-testid="footer-terms">{t("footer.terms", "Terms")}</a></p>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-carbon-800 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-titanium/40">
            © {new Date().getFullYear()} YANRE FITNESS EUROPE
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-titanium/30">
            Factory Direct · Since 1997
          </p>
        </div>
      </div>
    </footer>
  );
};
